export { default as isDeepLink } from './utils/isDeepLink';

export { getCalendarComposeDeeplink } from './utils/getCalendarComposeDeeplink';
export {
    getMailComposeDeeplink,
    getMailComposeReplyDeeplink,
    getMailToComposeDeeplink,
} from './utils/getMailComposeDeeplink';
export {
    getMailReadDeeplink,
    getMailReadDeeplinkForGroupMailbox,
} from './utils/getMailReadDeeplink';
export { MailTo } from './utils/MailTo';
